import { ADMISSION_PRIORITIES, admissionPriorityFromSource, isAdmissionPriority, type AdmissionPriority } from '@his/shared';
import { tr } from '@/lib/i18n-core';

export function admissionPriorityOf(request: { urgency: string | null } | null): AdmissionPriority {
  const urgency = request?.urgency ?? null;
  return isAdmissionPriority(urgency) ? urgency : admissionPriorityFromSource(request ? 'opd' : 'direct');
}

export function admissionPriorityChoices(): { value: AdmissionPriority; label: string }[] {
  return ADMISSION_PRIORITIES.map((value) => ({ value, label: tr('ipd', `priority_${value}`) }));
}
